// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"fee5cd2a","436":"2300b8f3","453":"f394a27d","501":"290e0490","606":"d315dfb6","925":"2c5e3bb6"}[chunkId] + ".chunk.js";
};